/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserCompanyResponseV3LogoFromJSON, InternalUserCompanyResponseV3LogoToJSON, } from './InternalUserCompanyResponseV3Logo';
/**
 * @export
 */
export const InternalUserCompanyResponseV3TypeEnum = {
    Company: 'company'
};
/**
 * Check if a given object implements the InternalUserCompanyResponseV3 interface.
 */
export function instanceOfInternalUserCompanyResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function InternalUserCompanyResponseV3FromJSON(json) {
    return InternalUserCompanyResponseV3FromJSONTyped(json, false);
}
export function InternalUserCompanyResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'name': json['name'],
        'shortDescription': json['short_description'] == null ? undefined : json['short_description'],
        'logo': json['logo'] == null ? undefined : InternalUserCompanyResponseV3LogoFromJSON(json['logo']),
    };
}
export function InternalUserCompanyResponseV3ToJSON(json) {
    return InternalUserCompanyResponseV3ToJSONTyped(json, false);
}
export function InternalUserCompanyResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'name': value['name'],
        'short_description': value['shortDescription'],
        'logo': InternalUserCompanyResponseV3LogoToJSON(value['logo']),
    };
}
